module.exports = __webpack_public_path__ + "static/media/photo-1-2-sm.77ab4f0a.jpeg";